// extracted by mini-css-extract-plugin
module.exports = {"link":"PromoBannerCTA_link__WK8qG","button":"PromoBannerCTA_button__O_5Qe"};